@use 'nhsuk-frontend/components/back-link' as *;

:host {
	display: block;
}